import React from 'react'
import styled from '@emotion/styled'
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Select,
  Switch,
  TextField,
  Typography
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { MODAL_TYPE } from '../../utils/constants'
import AddIcon from '@mui/icons-material/Add'
import calendarImage from '../../assets/calendar.svg'

export const ModalContent = styled(Paper)(({ theme, type }) => {
  if (type === MODAL_TYPE.DEAL_REPORT_STATUS) {
    return {
      borderRadius: '12px,',
      background: theme.palette.modal.primary
    }
  }
  return {
    borderRadius: '12px,',
    background: theme.palette.modal.primary,
    paddingBottom: '24px',
    paddingTop: '24px'
  }
})

export const SearchIconAutoComplete = styled(SearchIcon)(({ theme }) => ({
  color: theme.palette.button.save.primary
}))

export const InputBaseStyle = styled(TextField)(({ theme, error, background = 'transparent' }) => {
  let border = 'none'

  if (error === 'true') {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }

  return {
    border,
    width: '100%',
    height: '32px',
    fontFamily: 'Nunito',
    fontSize: '14px',
    background: 'transparent',
    borderRadius: '4px',
    '& .MuiTextField-root': {
      height: '32px',
      '-webkit-flex-direction': 'row',
      backgroundColor: 'transparent !important',
      border: '1px solid black !important',
      borderRadius: '4px'
    },
    '& .MuiFormControl-root': {
      display: 'block',
      padding: 0
    },
    '& .MuiInputBase-input': {
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingRight: '12px',
      paddingLeft: '8px',
      background: background
    }
  }
})

export const ModalBottomStyle = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  marginTop: '40px',
  justifyContent: 'space-between',
  alignItems: 'end',
  paddingBottom: '24px'
}))

export const FormError = styled(Typography)(({ theme }) => ({
  color: theme.palette.button.delete.primary,
  fontSize: '14px',
  display: 'blocked',
  position: 'absolute'
}))

export const ModalContainer = styled(Box)(() => ({
  paddingLeft: '32px',
  paddingRight: '32px'
}))

export const Container = styled('form')(() => ({
  marginTop: '24px',
  marginBottom: '24px',
  display: 'grid',
  gap: '20px',
  width: '100%'
}))

export const ContainerRow = styled(Box)(() => ({
  marginTop: '24px',
  marginBottom: '24px',
  display: 'flex',
  width: '100%'
}))

export const SubContainer = styled(Grid)(() => ({
  margin: '22px'
}))

export const UnVisibleSubmitButton = styled(Button)({
  display: 'none'
})

export const SubContainerRow = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  width: '100%'
}))

export const SubContainerRowItem = styled(Box)({
  flex: 1
})

export const IOSSwitch = styled(props => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginRight: '15px',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}))

export const AutocompleteStyle = styled(Autocomplete)(({ theme, error }) => {
  let border = 'none'
  if (error) {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }

  return {
    margin: 0,
    backgroundColor: theme.palette.separators.primary,
    border,
    width: '100%',
    height: '32px',
    borderRadius: '4px',
    '& .Mui-disabled': {
      backgroundColor: theme.palette.card.primary
    },
    '& .Mui-disabled .MuiSvgIcon-root': {
      color: theme.palette.switch.unactive
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.button.save.primary
    },
    '& .MuiAutocomplete-clearIndicator': {
      color: theme.palette.button.save.primary
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'transparent'
      },
      '&:hover:not(.Mui-disabled) fieldset': {
        borderColor: 'transparent' // Remove the hover border
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent' // Remove the focus border
      }
    },
    '& .MuiAutocomplete-popupIndicator': {
      '&:hover': {
        backgroundColor: 'transparent' // Remove hover background color for the indicator
      }
    }
  }
})

export const TextFieldModalStyle = styled(TextField)(({ theme, myerror }) => {
  let border = 'none'
  if (myerror === 'true') {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }
  return {
    backgroundColor: '#39393C',
    overflowY: 'auto',
    borderRadius: '4px',
    '& .Mui-error': {
      border
    }
  }
})

export const StyleSelect = styled(Select)(() => {
  return {
    width: '100%',
    height: '32px !important',
    fontSize: '14px',
    lineHeight: 'normal',
    '& .MuiSelect-select': {
      padding: '0px !important'
    },
    '&.MuiInputBase-root': {
      fontSize: '14px',
      padding: '0px 11px !important',
      '::placeholder': {
        color: 'grey',
        fontSize: '16px'
      }
    },
    '& .MuiSvgIcon-root': {
      fill: '#A4A4FF'
    },
    '&::placeholder': {
      color: 'green'
    }
  }
})

export const AddIconStyle = styled(AddIcon)(({ theme }) => ({
  width: '32px',
  height: '24px',
  borderRadius: '4px',
  padding: '0px',
  backgroundColor: theme.palette.button.edit.primary,
  margin: '5px 0px',
  color: '#000'
}))

export const TextFieldStyle = styled(TextField)(({ theme, myerror, value }) => {
  let color = 'white !important'
  if (!value) {
    color = 'grey'
  }
  return {
    border: myerror === 'true' ? `1px solid ${theme.palette.button.delete.primary}` : 'none',
    borderRadius: '4px',
    width: '100%',
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="date"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& .MuiInputBase-input': {
      padding: '11px 8px',
      color
    }
  }
})
